<template>
	<div id="Main">
		<div class="content">
			<van-image class="logo" width="33%" fit="contain" :src="require('../../assets/images/service/logo.png')" />
			<div class="inputbox">
				<van-icon class="icon" :name="require('../../assets/images/service/account.png')" />
				<van-field class="input" type="number" v-model="phone" placeholder="输入股权账户号/股东编号" />
			</div>
			<div class="inputbox">
				<van-icon class="icon" :name="require('../../assets/images/service/cipher.png')" />
				<van-field class="input" type="password" v-model="passw" placeholder="输入账户密码（6位数字）" />
			</div>
			<div class="code">
				<div class="inputbox">
					<van-icon class="icon" :name="require('../../assets/images/service/codeicon.png')" />
					<van-field class="input" v-model="code" maxlength="4" placeholder="验证码" />
				</div>
				<div class="codeimg" @click="getcode">
					<van-image class="img" width="6.5rem" height="3rem" fit="contain" :src="codeimg" />
					<van-icon class="icon" :name="require('../../assets/images/service/refresh.png')" />
				</div>
			</div>
			<div class="forget">
				<span @click="forget">忘记密码？</span>
			</div>
			<van-button round type="info" class="submit" @click="check()">登录</van-button>
		</div>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	import {
		url
	} from '../../libs/api/index.js';
	export default {
		components: {},
		data() {
			return {
				phone: '',
				passw: '',
				code: '',
				codeimg: '',
				codetext: '',
				openId: '',
			}
		},
		methods: {
			check() { //先验证是否绑定微信号，已绑定时验证openid是否一致
				let t = this;
				axiosPost.getRealNameBindByCode({
					shareholderCode: axiosPost.user(this.phone)
				}).then((res) => { /* 验证是否实名 */
					if (res.data.code == 200) { //openId 存在并且和现有openId 相等
						let back = res.data.data;
						window.console.log('back---',back);
						window.console.log('back.openId---',back.openId);
						if ((back && back.openId == '')||(back && back.openId==undefined)) {
							t.submit()
						} else {
							if(t.openId==back.openId){
								t.submit()
							}
							else{
								this.$toast({
									duration: 4000,
									message: '该股东已绑定其他微信号!'
								});
							}
						}
						// if(res.data.data && res.data.data.authenticationStatus && res.data.data.authenticationStatus==1){
						// 	this.$toast({duration:4000,message:'此账号已实名！'});
						// }
					} else {
						this.$toast({
							duration: 4000,
							message: res.data.msg
						});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			submit() {
				var t = this;
				if (this.phone == '') {
					this.$toast({
						duration: 4000,
						message: '账号不能为空'
					});
					return false
				}
				if (this.passw == '') {
					this.$toast({
						duration: 4000,
						message: '账号密码不能为空'
					});
					return false
				}
				if (this.code == '') {
					this.$toast({
						duration: 4000,
						message: '请填写验证码'
					});
					return false
				}
				if (this.code.toUpperCase() != this.codetext.toUpperCase()) {
					this.$toast({
						duration: 4000,
						message: '验证码不正确'
					});
					this.getcode()
					return false
				}
				this.$toast.loading({
					message: '登录中...',
					forbidClick: true,
					duration: 0
				});
				let number = axiosPost.user(this.phone)
				let params = '2904;' + number + ';' + this.passw + ';;;;;'
				axiosPost.getdatalogin(params, this.openId).then((res) => {
					window.console.log(res)
					this.$toast.clear();
					if (res.data.filter && res.data.filter.msg) {
						this.$dialog.alert({
							title: '提示',
							message: res.data.filter.msg,
						}).then(() => {
							if (res.data.filter.code == 0) {
								share()
							}
						});
					} else {
						share()
					}

					function share() {
						let str = res.data.data
						// 登录
						if (res.data.code == 200) {
							let code = str.slice(0, str.indexOf(';'))
							if (code == 200) {
								axiosPost.getShare({
									shareholderCode: number
								}).then((res) => { /* 验证是否实名 */
									if (Object.keys(res.data.data).length && res.data.data.authenticationStatus && res.data.data.authenticationStatus ==
										1) {
										if (t.passw !== '222222') {
											t.$router.push({
												path: '/queryindex',
												query: {
													openId: t.openId
												}
											})
										} else {
											t.$dialog.confirm({
												title: '提示',
												message: '该账户为初始密码，请先修改初始密码后使用相关服务！'
											}).then(() => {
												t.$router.push({
													path: '/obtaincode',
													query: Object.assign(res.data.data, {
														from: 'register'
													})
												})
											}).catch(() => {

											});
										}

									} else {
										if (t.passw !== '222222') {
											t.popup('您尚未实名认证，是否前往认证！')
										} else {
											t.popup('该账户为初始密码，请先办理实名认证，再登录修改初始密码后使用相关服务！')
										}
									}
								}).catch((res) => {
									window.console.log(res)
								})
							} else if (code == 400) {
								let s = str.slice(str.indexOf(';') + 1, str.indexOf('\\r'));
								if (s.indexOf('密码有误') != -1) {
									s = '账号或密码错误';
								}
								t.$toast({
									duration: 4000,
									message: s
								});
								t.getcode();
							} else { /* 错误 */
								t.$toast({
									duration: 4000,
									message: str.slice(str.indexOf(';') + 1, str.indexOf('\\r')) + '，请稍后再试！'
								});
								t.getcode();
							}
						} else {

							let s = res.data.msg.slice(0, res.data.msg.indexOf('\\r'));
							if (s.indexOf('密码有误') != -1) {
								s = '账号或密码错误';
							}
							// t.$toast({duration:4000,message: res.data.msg.slice(0, res.data.msg.indexOf('\\r'))});
							t.$toast({
								duration: 4000,
								message: s
							});
							t.getcode();
						}
					}
				}).catch((res) => {
					this.$toast.clear();
					window.console.log(res)
				})
			},
			forget() {
				this.$router.push({
					path: '/forget'
				})
			},
			getcode() { /* 获取图片验证码 */
				window.console.log(url)
				axiosPost.getcode('').then((res) => {
					if (res.data.code == 200) {
						this.codeimg = url + 'app/file/downByTmpPath?path=' + res.data.data.path
						this.codetext = res.data.data.validCode
					} else {
						this.$toast({
							duration: 4000,
							message: res.data.msg
						});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			popup(msg) {
				let t = this;
				this.$dialog.confirm({
					title: '提示',
					message: msg
				}).then(() => {
					this.$router.push({
						path: '/attestationlogin',
						query: {
							openId: this.openId,
						}
					})
				}).catch(() => {
					window.console.log('t.passw---', t.passw);
					if (t.passw != '222222') {
						this.$router.push({
							path: '/msghtml',
							query: {
								// text: '菜单刷新有延时，请点击公众号右上角头像，进行相关操作！',
								text: '登录成功，已绑定账号。',
							}
						})
					}

				});
			}
		},
		mounted() {
			this.openId = this.$route.query.openId
			this.getcode();
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		min-height: 100vh;
		display: flex;
		justify-content: center;
		flex-direction: column;

		.logo {
			margin-bottom: 3rem;
		}

		.forget {
			margin-bottom: 2rem;
			width: 70%;
			margin-left: auto;
			margin-right: auto;
			font-size: 1.4rem;
			text-align: left;
			color: #0078ff;
		}

		.code {
			display: flex;
			width: 70%;
			margin-left: auto;
			margin-right: auto;

			.inputbox {
				width: auto;
				flex: 1;
			}

			.codeimg {
				height: 4rem;
				padding-left: 1rem;
				line-height: 4rem;
				vertical-align: middle;

				.img {
					vertical-align: middle;
					border: 1px solid rgba(200, 200, 200, .5);
					padding: 2px 3px;
				}

				.icon {
					vertical-align: middle;
					margin-left: 1rem;
				}
			}
		}

		.inputbox {
			display: flex;
			margin-bottom: 2rem;
			width: 70%;
			margin-left: auto;
			margin-right: auto;
			border-bottom: 1px solid #ebebeb;

			.icon {
				display: flex;
				justify-content: center;
				flex-direction: column;
			}

			.input {
				flex: 1;
				padding: 0 1rem;
				height: 4rem;
				line-height: 4rem;

				&:not(:last-child):after {
					display: none;
				}
			}
		}

		.submit {
			width: 70%;
			background-color: #fa6b6b;
			border: 0;
			margin-top: 3rem;
			font-size: 1.6rem;
		}
	}
</style>
